import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import StageHeader from '../../components/stageHeader';

import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './bol.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsService from '../../services/axios/tmsService';
import qs from 'qs';
@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
    },
})
export default class Bol extends Vue {
    truckloadForm: any = {};
    bol: any = {};

    created() {
        this.getOrderBol();
    }

    getOrderBol() {
        tmsServiceBackend.get(`/tms/order/${this.$route.params.id}/bol/detail`).then(
            (res: any) => {
                this.bol = res.data.data;
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    getPdf() {
        let host = window.location.hostname;
        let domain;
        if (host == 'localhost' || host == 'clientdev.freightapp.com') {
            domain = 'dev.freightapp.com';
        } else if (host == 'clientstage.freightapp.com' || host == 'shipstage.unisco.com') {
            domain = 'staging.freightapp.com';
        } else if (
            host == 'client.freightapp.com' ||
            host == 'ship.unisco.com' ||
            host == 'demo.unisco.com'
        ) {
            domain = 'tms.freightapp.com';
        }
        let UserToken = localStorage.getItem('UserToken');
        let UserID = localStorage.getItem('UserID');
        let authToken = window.btoa(UserID + ':' + UserToken);
        window.open(
            `https://${domain}/tms_pdf_bol.php?order_id=${
                this.$route.params.id
            }&authorization=${authToken}`
        );
        tmsService.post(`/tms_pdf_bol.php`, qs.stringify(this.bol)).then(
            (res: any) => {
                console.log(res);
            },
            (err: any) => {
                console.log(err);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/bol/index.ts